import { Tooltip, TooltipTrigger, TooltipContent } from "./ui/tooltip";
import { GLOSSARY } from "../lib/glossary";

// Reusable hover tooltip. Pass a glossary `term`, or explicit `title`/`desc`/`color`.
export const InfoTip = ({ term, title, desc, color, children, side = "top", className = "" }) => {
  const g = term ? GLOSSARY[term] : null;
  const t = title ?? g?.title;
  const d = desc ?? g?.desc;
  const c = color ?? g?.color;
  if (!d) return children;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={`cursor-help ${className}`}>{children}</span>
      </TooltipTrigger>
      <TooltipContent
        side={side}
        data-testid="info-tip"
        className="max-w-[268px] bg-[#0b0d10] border border-white/15 text-white p-3 shadow-2xl shadow-black/50 z-[60]"
      >
        {t && (
          <div className="font-heading font-bold text-[11px] mb-1 tracking-tight" style={c ? { color: c } : {}}>
            {t}
          </div>
        )}
        <div className="text-[11px] leading-relaxed text-muted-foreground">{d}</div>
      </TooltipContent>
    </Tooltip>
  );
};
